import * as React from 'react';
import { SeparatorBaseContainer, SeparatorLineBase } from './SeparatorBase';

export const SeparatorWithContent: React.FC = ({ children }) => (
  <SeparatorBaseContainer>
    <SeparatorLineBase />
    {children}
    <SeparatorLineBase />
  </SeparatorBaseContainer>
);
